import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { TooltipV2, theme } from '@acorns/web-components'
import {
  getWindow,
  useAnalyticsClient,
  useRemoteStrings,
} from '@acorns/web-utils'

import { DESKTOP_SHARING_MODAL } from 'utils/testing/testIDs'

import { ACTIONS, shareAnalyticsOptions } from '../analytics'
import useTooltip from '../hooks/useTooltip'
import {
  BlackButton,
  ButtonWrapperColGrid,
  ModalContent,
  ModalHeader,
  ModalSubtext,
  ModalText,
} from './styled-components'

export const ShareRecapModal = ({
  beneficiaryName,
  publicUrl,
}: {
  beneficiaryName: string
  publicUrl: string
}): React.ReactElement => {
  const analytics = useAnalyticsClient()
  const { getRemoteString } = useRemoteStrings()
  const { showTooltip, setShowTooltip } = useTooltip()

  const handleCopyLink = () => {
    navigator.clipboard.writeText(publicUrl)
    setShowTooltip(true)

    analytics.track(ACTIONS.BUTTON_TAPPED, {
      ...shareAnalyticsOptions,
      event_description: 'Early Quarterly Recaps Share Modal Link Copy Tapped',
      object_name: 'earlyQuarterlyRecapShareModalLinkCopy',
    })
  }

  const handleCopyEmail = () => {
    const subject = getRemoteString({
      key: 'early.recap.share.email.subject.1variable',
      variables: [beneficiaryName],
    })

    const body = getRemoteString({
      key: 'early.recap.share.email.body.1variable',
      variables: [beneficiaryName],
    })
    getWindow().location.href = `mailto:?body=${body}%0D%0A%0D%0A${publicUrl}&subject=${subject}`

    analytics.track(ACTIONS.BUTTON_TAPPED, {
      ...shareAnalyticsOptions,
      event_description: 'Early Quarterly Recaps Share Modal Email Copy Tapped',
      object_name: 'earlyQuarterlyRecapShareModalEmailCopy',
    })
  }

  return (
    <ModalContent data-testid={DESKTOP_SHARING_MODAL}>
      <ModalHeader>
        {getRemoteString({ key: 'early.recap.modal.share.header' })}
      </ModalHeader>
      <ModalText>
        {getRemoteString({
          key: 'early.recap.potential.drawer.body.variable',
          variables: [beneficiaryName],
        })}
      </ModalText>
      <ModalSubtext>
        {getRemoteString({ key: 'early.recap.potential.drawer.footer' })}
      </ModalSubtext>
      <ButtonWrapperColGrid>
        <BlackButton styleType="dark" onPress={handleCopyEmail}>
          <AcornsIcon
            color={theme.colors.white}
            icon={AcornsIcon.Icon.UtilityMailFv}
            width={24}
          />
          <span>
            {getRemoteString({
              key: 'early.recap.share.email',
            })}
          </span>
        </BlackButton>
        <TooltipV2
          content={getRemoteString({
            key: 'early.recap.gifts.no_gifts.tooltip',
          })}
          placement={'top'}
          visibleOverride={showTooltip}
        >
          <BlackButton styleType="dark" onPress={handleCopyLink}>
            <AcornsIcon icon={AcornsIcon.Icon.UtilityShareIosFv} width={24} />
            <span>
              {getRemoteString({
                key: 'early.recap.share.copy_link',
              })}
            </span>
          </BlackButton>
        </TooltipV2>
      </ButtonWrapperColGrid>
    </ModalContent>
  )
}
